import { UOM } from 'constants/common';
import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';

interface ProductCardAttributesProps {
  attributes?: Attribute[];
  unitOfMeasure: string;
}

const ProductCardAttributes = ({
  attributes,
  unitOfMeasure
}: ProductCardAttributesProps) =>
  attributes?.length > 0 &&
  attributes
    .filter((attr) => attr.uom === unitOfMeasure || attr.uom === UOM.c62)
    .map(
      ({ name, value }) =>
        name && (
          <div key={`${name}-${value}`} data-testid="product-attributes">
            <p
              className={cx(
                styles['product-comparison__card-specifications-label'],
                'cat-u-theme-typography-footnote-bold m-0'
              )}
            >
              {name}
            </p>
            <p className="cat-u-theme-typography-footnote m-0">{value}</p>
          </div>
        )
    );

export default ProductCardAttributes;
